import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axiosInstance from "../../api/axiosConfig.jsx";

const TableModal = ({ isOpen, onClose, table, onTableAdded }) => {
    const [seats, setSeats] = useState(table?.seats || 4);
    const [companyName, setCompanyName] = useState(table?.companyName || '');
    const [tableNumber, setTableNumber] = useState(table?.tableNumber || '');
    const [room, setRoom] = useState(table?.room || '');

    useEffect(() => {
        if (table) {
            setSeats(table.seats);
            setCompanyName(table.companyName);
            setTableNumber(table.tableNumber);
            setRoom(table.room);
        }
    }, [table]);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        const newTable = {
            company: { companyName },
            seats,
            x: table.x,
            y: table.y,
            tableNumber,
            room
        };

        try {
            await axiosInstance.post('/tables/create', newTable);
            alert('Tafel toegevoegd!');
            onTableAdded();
        } catch (error) {
            console.error('Error adding table:', error.response?.data || error.message);
            alert('Er is een fout opgetreden bij het toevoegen van de tafel.');
        }
    };

    return (
        <div className={`modal ${isOpen ? 'd-block' : 'd-none'}`} tabIndex="-1" role="dialog" style={{ height: '90vh' }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Nieuwe tafel toevoegen</h5>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label>Stoelen:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={seats}
                                    onChange={(e) => setSeats(parseInt(e.target.value, 10))}
                                />
                            </div>
                            <div className="form-group">
                                <label>Bedrijfsnaam:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={companyName}
                                    readOnly
                                />
                            </div>
                            <div className="form-group">
                                <label>Tafelnummer:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={tableNumber}
                                    onChange={(e) => setTableNumber(parseInt(e.target.value, 10))}
                                />
                            </div>
                            <div className="form-group">
                                <label>Ruimte:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={room}
                                    onChange={(e) => setRoom(e.target.value)}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                            Tafel toevoegen
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Annuleren
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableModal;